document.documentElement.className = document.documentElement.className.replace('no-js', 'js');

window.theme = {
    info: {
        name: 'Symmetry',
        version: '7.2.1'
    },
    device: {
        hasTouch: window.matchMedia('(any-pointer: coarse)').matches,
        hasHover: window.matchMedia('(hover: hover)').matches
    },
    mediaQueries: {
        md: '(min-width: 768px)',
        productMediaCarouselBreak: '(min-width: 1041px)'
    },
    routes: window.themeRoutes || {},
    strings: window.themeStrings || {},
    settings: window.themeSettings || {}
};

theme.inlineNavigationCheck = function () {
    var pageHeader = document.querySelector('.pageheader'),
        inlineNavContainer = pageHeader.querySelector('.logo-area__left__inner'),
        inlineNav = inlineNavContainer.querySelector('.navigation--left');
    if (inlineNav && getComputedStyle(inlineNav).display != 'none') {
        var inlineMenuCentered = document.querySelector('.pageheader--layout-inline-menu-center'),
            logoContainer = document.querySelector('.logo-area__middle__inner');
        if (inlineMenuCentered) {
            var rightWidth = document.querySelector('.logo-area__right__inner').clientWidth,
                middleWidth = logoContainer.clientWidth,
                logoArea = document.querySelector('.logo-area'),
                computedLogoAreaStyle = getComputedStyle(logoArea),
                logoAreaInnerWidth = logoArea.clientWidth - Math.ceil(parseFloat(computedLogoAreaStyle.paddingLeft)) - Math.ceil(parseFloat(computedLogoAreaStyle.paddingRight)),
                availableNavWidth = logoAreaInnerWidth - Math.max(rightWidth, middleWidth) * 2 - 40;
            inlineNavContainer.style.maxWidth = availableNavWidth + 'px';
        }

        var firstInlineNavLink = inlineNav.querySelector('.navigation__item:first-child'),
            lastInlineNavLink = inlineNav.querySelector('.navigation__item:last-child');
        if (lastInlineNavLink) {
            var inlineNavWidth = null;
            if (document.querySelector('html[dir=rtl]')) {
                inlineNavWidth = firstInlineNavLink.offsetLeft - lastInlineNavLink.offsetLeft + firstInlineNavLink.offsetWidth;
            } else {
                inlineNavWidth = lastInlineNavLink.offsetLeft - firstInlineNavLink.offsetLeft + lastInlineNavLink.offsetWidth;
            }
            if (inlineNavContainer.offsetWidth >= inlineNavWidth) {
                pageHeader.classList.add('pageheader--layout-inline-permitted');
                var tallLogo = logoContainer.clientHeight > lastInlineNavLink.clientHeight + 20;
                if (tallLogo) {
                    inlineNav.classList.add('navigation--tight-underline');
                } else {
                    inlineNav.classList.remove('navigation--tight-underline');
                }
            } else {
                pageHeader.classList.remove('pageheader--layout-inline-permitted');
            }
        }
    }
};

theme.setInitialHeaderHeightProperty = () => {
    const section = document.querySelector('.section-header');
    if (section) {
        document.documentElement.style.setProperty('--theme-header-height', Math.ceil(section.clientHeight) + 'px');
    }
};

function changeVariant(element, imageProduit, imageProduit2, linkProduit, titreProduit, prix, prixAvant, sousTitreProduit, available) {
    element.parentElement.querySelector(".active").classList.remove("active");
    element.classList.add("active");

    if (element.classList.contains("originale") === true) {
        element.parentElement.parentElement.parentElement.parentElement.parentElement.parentElement.querySelector(".quickbuy-toggle").setAttribute("style", "display: block;");
    } else {
        element.parentElement.parentElement.parentElement.parentElement.parentElement.parentElement.querySelector(".quickbuy-toggle").setAttribute("style", "display: none;");
    }

    element.parentElement.parentElement.parentElement.parentElement.parentElement.parentElement.querySelector(".image-page-button.image-page-button--previous").setAttribute("style", "display: none;");
    element.parentElement.parentElement.parentElement.parentElement.parentElement.parentElement.querySelector(".image-page-button.image-page-button--next").setAttribute("style", "display: none;");

    // Titre produit
    element.parentElement.parentElement.parentElement.querySelector(".product-block__title").textContent = titreProduit;

    // Image produit
    element.parentElement.parentElement.parentElement.parentElement.parentElement.parentElement.querySelector(".product-block__image--active img").removeAttribute("srcset");
    element.parentElement.parentElement.parentElement.parentElement.parentElement.parentElement.querySelector(".product-block__image--active img").setAttribute("src", imageProduit);

    element.parentElement.parentElement.parentElement.parentElement.parentElement.parentElement.querySelector(".product-block__image--show-on-hover img").removeAttribute("srcset");
    element.parentElement.parentElement.parentElement.parentElement.parentElement.parentElement.querySelector(".product-block__image--show-on-hover img").setAttribute("src", imageProduit2);

    // Url produit
    element.parentElement.parentElement.parentElement.querySelector(".product-link").setAttribute("href", linkProduit);
    element.parentElement.parentElement.parentElement.parentElement.parentElement.parentElement.querySelector(".product-link").setAttribute("href", linkProduit);

    // Size produit
    element.parentElement.parentElement.parentElement.querySelector(".product-size").textContent = sousTitreProduit;

    // Prix
    if (available == "true") {
        available = true;
    } else {
        available = false;
    }
    element.parentElement.parentElement.parentElement.querySelector(".product-price .price").innerHTML = '<div class="price__default"><span class="price__current">' + prix + '</span><span class="price__was">' + prixAvant + '</span></div><span style="display: ' + (available ? 'none' : 'block') + ';" class="price-label price-label--sold-out">Épuisé</span>';
}

// Rendre changeVariant global
window.changeVariant = changeVariant;